const apiEndpoints = {
	TEAM: (teamId) => `/teams/${teamId}`,
	TEAM_PLAYERS: (teamId) => `/teams/${teamId}/players`,
	TEAM_PLAYER_SAVE: (teamId) => `/teams/${teamId}/player`,
	TEAM_PLAYER_UPDATE: (teamId, playerId) =>
		`/teams/${teamId}/player/${playerId}`,
	USER_EVENTS: () => "/me/events",
	USER_SEASONS: () => "/me/seasons",
	USER_TEAMS: (seasonId) =>
		`/me/teams${seasonId ? `?seasonId=${seasonId}` : ""}`,
	SEASON: (seasonId) => `/seasons/${seasonId}`,
	SEASON_TEAMS: (seasonId) => `/seasons/${seasonId}/teams`,
	EVENT: (eventId) => `/events/${eventId}`,
	TIMEZONES: () => "/events/timezones",
	EVENT_DATA: (eventId) => `/events/${eventId}/prestostats/data`,
	SAVE_BOXSCORE: (eventId) => `/events/${eventId}/prestostats/boxscore`,
	EVENT_TEAM_PLAYERS: (teamId, eventId) =>
		`/events/${eventId}/teams/${teamId}/players`,
	SAVE_SEASON_SETTINGS: (seasonId) => `/seasons/${seasonId}/settings`,
	GET_SEASON_SETTINGS: (env, seasonId) =>
		`/${env}/seasons/${seasonId}/settings/v1.json`
};

export default apiEndpoints;
